import { render, staticRenderFns } from "./EditingButton.vue?vue&type=template&id=55fe06e6"
import script from "./EditingButton.vue?vue&type=script&lang=js"
export * from "./EditingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports